<template>
  <div class="d-flex c">
    <v-btn
      @click="() => onClickStatus('created')"
      :disabled="status !== 'noSchedule'"
      :color="['noSchedule'].includes(status) ? 'yellow' : ''"
      class="elevation-0"
      >Chưa có lịch</v-btn
    >
    <v-btn
      @click="() => onClickStatus('notApproved')"
      :disabled="status !== 'delivering' || !$auth.policies['import-orders:update-status-unapproved']"
      :color="['delivering'].includes(status) ? 'orange' : ''"
      class="elevation-0"
      >Đang giao</v-btn
    >
    <v-btn
      @click="() => onClickStatus('approved')"
      :disabled="status !== 'incompleteDelivery' || !$auth.policies['import-orders:update-status-approved']"
      :color="['incompleteDelivery'].includes(status) ? 'green' : ''"
      class="elevation-0"
      >Chưa giao đủ</v-btn
    >
    <v-btn
      @click="() => onClickStatus('supplierSent')"
      :disabled="status !== 'completeDelivery' || !$auth.policies['import-orders:update-status-suppliersent']"
      :color="['completeDelivery'].includes(status) ? 'green' : ''"
      class="elevation-0"
      >Đã giao đủ</v-btn
    >
  </div>
</template>
<script>
export default {
  props: {
    status: {
      type: String,
      default: 'created'
    }
  }
}
</script>
<style scoped>
.status-card {
  background: rgb(202, 202, 202);
  border: 1px solid;
}
.disabled {
  background: rgb(173, 47, 47);
}
</style>
